"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GooglePlaces = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@react-google-maps/api");
var _GoogleAutocomplete = require("./GoogleAutocomplete");
var _GooglePlaces = require("./GooglePlaces.types");
var _Progress = require("../components/Progress");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MapContainer = (0, _material.styled)(_material.Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    '& div.map': {
      height: '500px'
    }
  };
});
var GooglePlaces = exports.GooglePlaces = function GooglePlaces(_ref2) {
  var apiKey = _ref2.apiKey,
    defaultCenter = _ref2.defaultCenter,
    notifySelected = _ref2.onSelected;
  var center = (0, _react.useMemo)(function () {
    return defaultCenter === undefined ? _GooglePlaces.ANGEL_DE_LA_INDEPENDENCIA : defaultCenter;
  }, [defaultCenter]);
  var _useState = (0, _react.useState)(defaultCenter),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useLoadScript = (0, _api.useLoadScript)({
      googleMapsApiKey: apiKey,
      libraries: _GooglePlaces.GOOGLE_API_LIBRARIES
    }),
    isLoaded = _useLoadScript.isLoaded;
  var onChanged = function onChanged(address) {
    setSelected(address ? {
      lat: address.latitude,
      lng: address.longitude
    } : undefined);
    notifySelected(address);
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(MapContainer, {
    item: true,
    xs: 12
  }, isLoaded && (/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_GoogleAutocomplete.GoogleAutocomplete, {
    setSelected: onChanged
  }), /*#__PURE__*/_react["default"].createElement(_api.GoogleMap, {
    zoom: 15,
    center: selected !== null && selected !== void 0 ? selected : center,
    mapContainerClassName: "map"
  }, selected && /*#__PURE__*/_react["default"].createElement(_api.Marker, {
    position: selected
  })))), !isLoaded && /*#__PURE__*/_react["default"].createElement(_Progress.Progress, null)));
};